module.exports = __webpack_public_path__ + "r-v3/img/ml_58_00.29aa4292.jpg";